import React, { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { APP_LOGO } from "@lib/constants/AppConst";
import { useTypedSelector } from "@lib/redux";

const SITE_URL =
  import.meta.env.NODE_ENV === "development" ? "http://localhost:3000" : "/";
const defaultTitle = "Payment Hub";
const defaultSep = " | ";

type AppPageMetaProps = {
  children?: ReactNode;
  title: string;
  description?: string;
  schema?: string;
  image?: string;
  contentType?: string;
  twitter?: string;
  noCrawl?: boolean;
  updated?: string;
  published?: string;
  category?: string;
  tags?: string;

  [x: string]: any;
};
const AppPageMeta: React.FC<AppPageMetaProps> = ({ children, ...rest }) => {
  const { pathname } = useLocation();
  const { unseenCount } = useTypedSelector((state) => state.notifications);
  const title = rest.title
    ? rest.title + defaultSep + defaultTitle
    : defaultTitle;

  return (
    <HelmetProvider>
      <Helmet
        htmlAttributes={{
          lang: "en",
          itemscope: undefined,
          itemtype: `http://schema.org/${rest.schema || "CRM"}`,
        }}
        title={(unseenCount > 0 ? `(${unseenCount}) ` : "") + title}
        link={[
          {
            rel: "canonical",
            href: SITE_URL + pathname,
          },
          {
            rel: "icon",
            type: "image/png",
            href: APP_LOGO.icon.light,
          },
        ]}
        ref={null}
      />
      {children}
    </HelmetProvider>
  );
};

export default AppPageMeta;
